<template>
	<div v-if="context">
		<nk-link v-if="detailURL && context.bild" :link="detailURL">
			<nk-image
				v-if="context.bild"
				:copyright="context.bildcopyright"
				:src="context.bild"
				ar="21:9"
				:alt="context.bildtext"
			/>
		</nk-link>
		<nk-image
			v-else-if="context.bild"
			:copyright="context.bildcopyright"
			:src="context.bild"
			ar="21:9"
			:alt="context.bildtext"
		/>
		<nk-box variant="sidebar">
			<nk-link v-if="detailURL" :link="detailURL" block>
				<nk-title size="lg">
					{{ context.titel }}
				</nk-title>
			</nk-link>
			<nk-title v-else size="lg">
				{{ context.titel }}
			</nk-title>
			<nk-address
				variant="vertical"
				v-bind="{...context.kontakt, ...context.adresse}"
			/>
		</nk-box>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 */
export default {
	name: 'NkSidebarBrancheneintrag',

	mixins: [TemplatesDefault],

	computed: {
		detailURL() {
			if (this.context.rubriken.length && this.context.rubriken[0].detailURL) {
				return this.context.rubriken[0].detailURL;
			}

			return '';
		},
	},
};
</script>
